import React from "react";
import { getProgramTypeIconClass } from "../../../functions";

const CardIcon = (props) => {
  return (
    <div
      className={`card-course-icon ${getProgramTypeIconClass(
        props.type,
        true,
      )}`}
    ></div>
  );
};

export default CardIcon;
